export default "__VITE_ASSET__DJ$Aro9$__"